import type {
  StaffLineItem,
  HardCostLineItem,
  OfferingRoleId,
  HardCostCategoryId,
} from "@/lib/types/database/offerings";
import { OFFERING_ROLES, HARD_COST_CATEGORIES } from "@/lib/types/database/offerings";

export const LEGACY_ROLE_MAP: Record<string, OfferingRoleId> = {
  "Senior Engineer": "senior_engineer",
  "Engineer": "engineer",
  "Junior Engineer": "junior_engineer",
  "Project Manager": "project_manager",
  "Designer": "designer",
  "QA": "qa",
  "DevOps": "devops",
  senior_engineer: "senior_engineer",
  engineer: "engineer",
  junior_engineer: "junior_engineer",
  project_manager: "project_manager",
  designer: "designer",
  qa: "qa",
  devops: "devops",
};

export function normalizeRole(role: unknown): OfferingRoleId | null {
  if (typeof role !== "string") return null;
  return LEGACY_ROLE_MAP[role] ?? (OFFERING_ROLES.some((r) => r.id === role) ? (role as OfferingRoleId) : null);
}

export function isValidStaffLineItem(item: unknown): item is StaffLineItem {
  if (!item || typeof item !== "object") return false;
  const o = item as Record<string, unknown>;
  const role = normalizeRole(o.role);
  return (
    role !== null &&
    typeof o.hours === "number" &&
    !Number.isNaN(o.hours) &&
    o.hours >= 0 &&
    (o.rate === undefined ||
      (typeof o.rate === "number" && !Number.isNaN(o.rate) && o.rate >= 0))
  );
}

export function toStaffLineItem(item: unknown): StaffLineItem | null {
  if (!item || typeof item !== "object") return null;
  const o = item as Record<string, unknown>;
  const role = normalizeRole(o.role);
  if (role === null) return null;
  const hours = typeof o.hours === "number" && !Number.isNaN(o.hours) ? o.hours : 0;
  const rate = o.rate != null && typeof o.rate === "number" && !Number.isNaN(o.rate) ? o.rate : undefined;
  return { role, hours, rate };
}

export const LEGACY_DESC_MAP: Record<string, HardCostCategoryId> = {
  License: "license",
  Hosting: "hosting",
  "Third Party": "third_party",
  Travel: "travel",
  Equipment: "equipment",
  Other: "other",
  license: "license",
  hosting: "hosting",
  third_party: "third_party",
  travel: "travel",
  equipment: "equipment",
  other: "other",
};

export function normalizeDescription(desc: unknown): HardCostCategoryId | null {
  if (typeof desc !== "string") return null;
  return LEGACY_DESC_MAP[desc] ?? (HARD_COST_CATEGORIES.some((c) => c.id === desc) ? (desc as HardCostCategoryId) : null);
}

export function isValidHardCostLineItem(item: unknown): item is HardCostLineItem {
  if (!item || typeof item !== "object") return false;
  const o = item as Record<string, unknown>;
  return (
    normalizeDescription(o.description) !== null &&
    typeof o.amount === "number" &&
    !Number.isNaN(o.amount) &&
    o.amount >= 0
  );
}

export function toHardCostLineItem(item: unknown): HardCostLineItem | null {
  if (!item || typeof item !== "object") return null;
  const o = item as Record<string, unknown>;
  const description = normalizeDescription(o.description);
  if (description === null) return null;
  const amount = typeof o.amount === "number" && !Number.isNaN(o.amount) ? o.amount : 0;
  return { description, amount };
}
